module.exports = __webpack_public_path__ + "img/12.a649ab89.jpg";